import { Box, CircularProgress } from "@mui/joy";

export default function LoadingView() {
  return (
    <Box display="flex" height="100%" alignItems="center" justifyContent="center">
      <CircularProgress />
    </Box>
  );
}
